// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"39dfe0dc","383":"53eab27c","461":"98ec61cb","632":"75891733","697":"7272b420","853":"a077e8c5","880":"db722635"}[chunkId] + ".chunk.css";
};